import resolveServiceWorkerContainer from '@Infra/ServiceWorker/resolveServiceWorkerContainer';

export type WatchApplicationReloadOptions = {
	readonly onControllerChange: () => void;
};

/**
 * Fires `onControllerChange` when the service worker taking control of this page changes — the
 * signal that a previously waiting update has just activated. This function only ever relays that
 * platform event: deciding what to do about it (this project reloads the page) is left entirely to
 * the caller. Resolves to a no-op unsubscribe when no service worker container is available
 * (unsupported browser, or jsdom under tests).
 */
const watchApplicationReload = (options: WatchApplicationReloadOptions): (() => void) => {
	const controllerContainer = resolveServiceWorkerContainer();

	if (!controllerContainer) {
		return () => {};
	}

	const handleControllerChange = (): void => options.onControllerChange();

	controllerContainer.addEventListener('controllerchange', handleControllerChange);

	return () => {
		controllerContainer.removeEventListener('controllerchange', handleControllerChange);
	};
};

export default watchApplicationReload;
